var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M10.3379 1.25C10.3539 1.25 10.3699 1.25001 10.386 1.25001H13.614C13.6301 1.25001 13.6462 1.25 13.6621 1.25C14.1832 1.24995 14.6495 1.24991 15.0265 1.3024C15.4394 1.3599 15.854 1.49282 16.1901 1.84089C16.5227 2.18528 16.6462 2.6038 16.7001 3.01872C16.7501 3.40382 16.75 3.88196 16.75 4.42482L16.75 6.1424H15.25V4.47091C15.25 3.86802 15.2485 3.48874 15.2126 3.21184C15.1791 2.9539 15.1279 2.9003 15.1111 2.88284C15.1108 2.88253 15.1105 2.88221 15.1101 2.88187C15.0958 2.86692 15.0512 2.82031 14.8196 2.78807C14.5585 2.75171 14.1984 2.75001 13.614 2.75001H10.386C9.80166 2.75001 9.44152 2.75171 9.18037 2.78807C8.94884 2.82031 8.90419 2.86692 8.88988 2.88187C8.88955 2.88221 8.88924 2.88253 8.88894 2.88284C8.87208 2.9003 8.82093 2.9539 8.78744 3.21184C8.75149 3.48874 8.75 3.86802 8.75 4.47091V6.1424H7.25V4.47091C7.25 4.45549 7.25 4.44012 7.25 4.42481C7.24996 3.88195 7.24993 3.40382 7.29992 3.01872C7.35379 2.6038 7.47734 2.18528 7.8099 1.84089C8.146 1.49282 8.56059 1.3599 8.97352 1.3024C9.35054 1.24991 9.81684 1.24995 10.3379 1.25Z",
    fill: "#000000",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1085 15.6335C18.8152 18.2884 18.6686 19.6158 17.9192 20.5322C17.6572 20.8526 17.347 21.1304 16.9997 21.3557C16.0066 22 14.6711 22 12.0001 22C9.32905 22 7.99354 22 7.0004 21.3557C6.65314 21.1304 6.34295 20.8526 6.08091 20.5322C5.3315 19.6158 5.18489 18.2883 4.89166 15.6335L3.76476 5.43042L20.2354 5.43042L19.1085 15.6335Z",
    fill: "#000000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M2.25 6.12195C2.25 5.70773 2.58579 5.37195 3 5.37195H21C21.4142 5.37195 21.75 5.70773 21.75 6.12195C21.75 6.53616 21.4142 6.87195 21 6.87195H3C2.58579 6.87195 2.25 6.53616 2.25 6.12195Z",
    fill: "#000000",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteFilled);
export default __webpack_public_path__ + "static/media/deleteFilled.a628421fa92d756a53d2d0aadf71b2c2.svg";
export { ForwardRef as ReactComponent };